// =====================================================================
// protocolService (EHR Protocolos / S63) — controle de doses no prontuário.
// Upload de foto/assinatura via FormData (multer .fields no backend).
// Serving de foto/assinatura = blob auth-gated (Bearer), igual ao resto do EHR.
// =====================================================================
import api from "./api";

export const listProtocols = async (patientId) =>
  (await api.get(`/patients/${patientId}/protocols`)).data; // { protocols: [{..., doses:[]}] }

export const createProtocol = async (patientId, payload) =>
  (await api.post(`/patients/${patientId}/protocols`, payload)).data;

export const cancelProtocol = async (patientId, protocolId) =>
  (await api.post(`/patients/${patientId}/protocols/${protocolId}/cancel`)).data;

// Aplica uma dose: foto (File) + assinatura (File) + obs — todos opcionais.
export const applyDose = async (patientId, protocolId, doseNumber, { photo, signature, notes } = {}) => {
  const fd = new FormData();
  if (photo) fd.append("photo", photo);
  if (signature) fd.append("signature", signature);
  if (notes) fd.append("notes", notes);
  const { data } = await api.post(
    `/patients/${patientId}/protocols/${protocolId}/doses/${doseNumber}/apply`, fd
  );
  return data; // { dose, stockWarning }
};

// Foto/assinatura da dose como objectURL (blob, Bearer) — pra <img> ou abrir.
export const getDosePhotoUrl = async (doseId) => {
  const { data } = await api.get(`/ehr/protocol-doses/${doseId}/photo`, { responseType: "blob" });
  return URL.createObjectURL(data);
};
export const getDoseSignatureUrl = async (doseId) => {
  const { data } = await api.get(`/ehr/protocol-doses/${doseId}/signature`, { responseType: "blob" });
  return URL.createObjectURL(data);
};

export const PROTOCOL_STATUS = {
  ativo: { label: "Em andamento", color: "#1565c0" },
  concluido: { label: "Concluído", color: "#2e7d32" },
  cancelado: { label: "Cancelado", color: "#757575" }
};

export const protocolErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_PROTOCOL_NAME_REQUIRED: "Informe o nome do protocolo.",
    ERR_PROTOCOL_DOSES_INVALID: "Número de doses inválido (1 a 120).",
    ERR_PROTOCOL_NOT_FOUND: "Protocolo não encontrado.",
    ERR_DOSE_NOT_FOUND: "Dose não encontrada.",
    ERR_DOSE_FILE_TOO_LARGE: "Arquivo muito grande (máx. 10 MB).",
    ERR_UPLOAD_MIMETYPE: "Tipo de arquivo inválido (use PNG/JPG).",
    ERR_PATIENT_NOT_FOUND: "Paciente não encontrado.",
    ERR_FILE_NOT_FOUND: "Arquivo não encontrado."
  };
  if (code && map[code]) return map[code];
  if (code && typeof code === "string" && !code.startsWith("ERR_")) return code;
  return "Não foi possível concluir a operação. Tente novamente.";
};
